import { render, staticRenderFns } from "./small_text_editor.vue?vue&type=template&id=c0e45c30&"
import script from "./small_text_editor.vue?vue&type=script&lang=js&"
export * from "./small_text_editor.vue?vue&type=script&lang=js&"
import style0 from "./small_text_editor.vue?vue&type=style&index=0&id=c0e45c30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports